import { render, staticRenderFns } from "./bookList.vue?vue&type=template&id=2706130c&scoped=true&"
import script from "./bookList.vue?vue&type=script&lang=js&"
export * from "./bookList.vue?vue&type=script&lang=js&"
import style0 from "./bookList.vue?vue&type=style&index=0&id=2706130c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2706130c",
  null
  
)

export default component.exports